import AOS from "aos";
import lozad from "lozad";

import {
	setBackgroundElement,
	detectCloseElement,
	buttonToTop,
	clickScrollToDiv,
	appendCaptchaASP,
	replaceSvgImages,
	countUpInit,
} from "./helper";
import { header } from "./header";
import { showMenu } from "./header-menu";
import { accordion } from "./accordion";
import { Fullpage, swiperInit } from "./swiper";
import { showMoreButton } from "./showMoreButton";
import { popup } from "./popup";
import { tabItem } from "./tabItem";
import { systemTabItem } from "./system-tab";
import { showMenuSpy } from "./menuSpy";
import menuspy from "menuspy";

$(document).ready(function () {
	Fullpage.init();
	introWebsite();
	setBackgroundElement();
	header.init();
	accordion();
	showMenu();
	showMoreButton();
	tabItem();
	popup();
	showMenuSpy();
	systemTabItem();
	watchObserveInputFile();
	swiperInit();
	slideCircle();
	replaceSvgImages();
	initExpandContent();
	countUpInit();

	$(".home-1-info").each(function () {
		let hasData = false;

		$(this)
			.find(".home-1-item")
			.each(function () {
				const numberText = $.trim($(this).find(".number").text());
				const pText = $.trim($(this).find("p").text());

				if (numberText !== "" || pText !== "") {
					hasData = true;
				}
			});

		if (!hasData) {
			$(this).hide(); // Ẩn toàn bộ .home-1-info nếu tất cả .home-1-item bên trong không có dữ liệu
		}
	});

	// Smooth scroll to section when clicking nav links
	$(".service-2-menu a").on("click", function (e) {
		e.preventDefault();

		const target = $(this).attr("href");
		const offset = $(".service-2").outerHeight();

		$("html, body").animate(
			{
				scrollTop: $(target).offset().top - offset,
			},
			500
		);

		window.history.pushState(null, "", target);
	});

	// Add active class to nav items and update URL on scroll
	$(window).on("scroll", function () {
		// Get current scroll position
		const scrollPosition = $(window).scrollTop();
		const windowHeight = $(window).height();
		const navHeight = $(".service-2").outerHeight();

		// Find the section that takes up the most space in the viewport
		let maxVisibleSection = null;
		let maxVisibleHeight = 0;

		$(".service-3-main").each(function () {
			const section = $(this);
			const sectionTop = section.offset().top - navHeight;
			const sectionHeight = section.outerHeight();
			const sectionBottom = sectionTop + sectionHeight;

			// Calculate how much of the section is visible
			const visibleTop = Math.max(scrollPosition, sectionTop);
			const visibleBottom = Math.min(scrollPosition + windowHeight, sectionBottom);
			const visibleHeight = Math.max(0, visibleBottom - visibleTop);

			// If this section has more visible height than previous maximum, it becomes active
			if (visibleHeight > maxVisibleHeight) {
				maxVisibleHeight = visibleHeight;
				maxVisibleSection = section;
			}
		});

		// Update active state and URL if we found a section
		if (maxVisibleSection) {
			const id = maxVisibleSection.attr("id");

			// Update active menu item
			$(".service-2-menu a").removeClass("active");
			$(`.service-2-menu a[href="#${id}"]`).addClass("active");

			// Update URL without affecting scroll
			const currentHash = window.location.hash;
			if (currentHash !== `#${id}`) {
				window.history.replaceState(null, "", `#${id}`);
			}
		}
	});

	// Trigger scroll event on page load to set initial active state
	$(window).trigger("scroll");
	clickServiceDetail();
	setTimeout(() => {
		AOS.init({
			offset: 100,
		});
	}, 0);
	setTimeout(() => {
		AOS.refresh();
	}, 1000);
});
function introWebsite() {
	const introDesktop = $(".section-intro-website").data("intro-desktop");
	const introMobile = $(".section-intro-website").data("intro-mobile");
	const introSection = $(".section-intro-website");

	// Create video element instead of Lottie player
	const videoElement = document.createElement("video");
	videoElement.setAttribute("autoplay", "");
	videoElement.setAttribute("muted", "");
	videoElement.muted = "muted";
	videoElement.setAttribute("playsinline", "");
	videoElement.style.width = "100%";
	videoElement.style.height = "100%";
	videoElement.style.objectFit = "cover";

	// Add event listeners for video
	videoElement.addEventListener("canplay", () => {
		console.log("Video can play");
		videoElement.play();
	});

	videoElement.addEventListener("play", () => {
		console.log("Video started playing");
	});

	// Key event: when video ends, fade out the intro
	videoElement.addEventListener("ended", () => {
		console.log("Video ended");
		introSection.addClass("fadeout-intro");
	});

	// Set fallback timeout in case video events don't fire
	setTimeout(() => {
		introSection.addClass("fadeout-intro");
	}, 10000); // Fallback after 10 seconds

	// Set video source based on screen size
	if (window.matchMedia("(min-width: 1200px)").matches) {
		videoElement.setAttribute("src", introDesktop);
	} else {
		videoElement.setAttribute("src", introMobile);
	}

	introSection.append(videoElement);
}
function clickServiceDetail() {
	$(".st96-group, .st96-group-2").on("click", function (e) {
		const href = $(this).attr("data-href");
		window.location.href = href;
	});
}
function initRecruitmentHover() {
	const recruitmentItems = document.querySelectorAll(".js-recruitment-item");

	recruitmentItems.forEach((item) => {
		const content = item.querySelector(".js-recruitment-content");
		const desc = item.querySelector(".js-recruitment-desc");

		if (desc) {
			const descHeight = desc.offsetHeight;
			// Add some padding to the translation value
			const translateY = descHeight - 10; // 20px padding
			item.style.setProperty("--translate-y", `${translateY}px`);
		}
	});
}

// Call the function when the document is ready
document.addEventListener("DOMContentLoaded", initRecruitmentHover);

// Recalculate on window resize
window.addEventListener("resize", initRecruitmentHover);

function slideCircle() {
	const items = $(".item-slide");
	const totalSlides = items.length;
	const visibleSlides = 5;
	let currentIndex = 0;

	function updateSlides() {
		items.each((index, item) => {
			// Remove all previous classes
			$(item).removeClass("slide-current slide-hidden slide-prev slide-next");

			// Calculate relative position from current index
			let position = (index - currentIndex + totalSlides) % totalSlides;

			// Calculate slide-current-index (1-5)
			let currentPosition = position + 1;

			// Reset attributes
			$(item).removeAttr("slide-current-index");

			if (currentPosition > visibleSlides) {
				// Get position relative to visible slides
				let relativePosition = position - visibleSlides;

				if (relativePosition === 0) {
					// First item after visible slides (next)
					$(item).addClass("slide-next");
				} else {
					// Hide other slides beyond visible range
					$(item).addClass("slide-hidden");
				}
			} else {
				// Add slide-current-index and slide-current class to visible slides
				$(item).attr("slide-current-index", currentPosition).addClass("slide-current");
			}

			// Handle prev slide - it's the last item in the circular rotation
			if (position === totalSlides - 1) {
				$(item).removeClass("slide-hidden").addClass("slide-prev");
			}

			// Keep track of original position
			$(item).attr("data-slide-index", index);
		});
	}

	// Initialize
	updateSlides();

	// Event handlers with animation lock
	let isAnimating = false;

	$(".btn-prev, .btn-next").on("click", function () {
		if (isAnimating) return;
		isAnimating = true;

		const isPrev = $(this).hasClass("btn-prev");
		currentIndex = (currentIndex + (isPrev ? -1 : 1) + totalSlides) % totalSlides;

		// Add transition class to all items
		items.addClass("transition-300");

		updateSlides();

		// Remove transition class after animation completes
		setTimeout(() => {
			items.removeClass("transition-300");
			isAnimating = false;
		}, 300);
	});

	// Auto slide every 3 seconds
	setInterval(() => {
		// Move to next slide
		currentIndex = (currentIndex + 1) % totalSlides;

		// Add transition class to all items
		items.addClass("transition-300");

		updateSlides();

		// Remove transition class after animation completes
		setTimeout(() => {
			items.removeClass("transition-300");
		}, 300);
	}, 3000); // 3000ms = 3 seconds
}

function watchObserveInputFile() {
	$('input[name="file-cv"]').on("change", function () {
		const file = this.files[0];
		if (file) {
			const fileName = file.name;
			// Create/update filename display
			const fileNameDisplay = $("<span>", {
				class: "file-name text-sm text-body-text-66 mt-1 block",
				text: "File CV: " + fileName,
			});

			// Remove existing filename display if any
			$(this).closest(".form-input-file").find(".file-name").remove();
			// Add new filename display
			$(this).closest(".form-input-file").append(fileNameDisplay);
		}
	});
}

var elm = document.querySelector("#main-service-detail");
var ms = new menuspy(elm, {
	activeClass: "active",
	threshold: 250,
});

var elm = document.querySelector("#main-service");
var ms = new menuspy(elm, {
	threshold: 250,
	activeClass: "active",
});
/*==================== Aos Init ====================*/

/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();

// Expand/collapse content functional

function initExpandContent() {
	const wrapContent = $(".wrap-expand-content");
	const ITEMS_TO_SHOW = 3;
	const textThuGon = $("html").attr("lang") === "ja" ? "縮小" : "Thu gọn";
	const textMoRong = $("html").attr("lang") === "ja" ? "詳細を見る" : "Xem thêm";
	wrapContent.each(function () {
		const links = $(this).find("a");

		if (links.length > ITEMS_TO_SHOW) {
			links.slice(ITEMS_TO_SHOW).hide();

			$(this)
				.next(".service-more")
				.find("a")
				.on("click", function (e) {
					e.preventDefault();
					const $this = $(this);
					const $hiddenLinks = $this
						.closest(".format-content")
						.find(".wrap-expand-content a:hidden");

					if ($hiddenLinks.length) {
						// Different animation options:

						// Fade effect
						$hiddenLinks.fadeIn(200);

						// Slide down with bounce
						// $hiddenLinks.slideDown(500).animate({opacity: 1}, {duration: 200, queue: false});

						// Fade in while sliding
						// $hiddenLinks.animate({
						//     opacity: 'show',
						//     height: 'show'
						// }, 500);

						// Custom animation
						// $hiddenLinks.animate({
						//     opacity: 1,
						//     height: 'toggle',
						//     marginTop: '10px'
						// }, {
						//     duration: 400,
						//     easing: 'swing'
						// });

						$this.html(
							`${textThuGon} <i class="group-hover:text-Primary-01 fa-sharp fa-thin fa-chevron-up"></i>`
						);
					} else {
						// Different hide animations:

						// Fade out
						$this
							.closest(".format-content")
							.find(".wrap-expand-content a")
							.slice(ITEMS_TO_SHOW)
							.fadeOut(200);

						// Slide up with fade
						// $this
						//     .closest(".format-content")
						//     .find(".wrap-expand-content a")
						//     .slice(ITEMS_TO_SHOW)
						//     .animate({
						//         opacity: 0,
						//         height: 'hide'
						//     }, 400);

						$this.html(
							`${textMoRong} <i class="group-hover:text-Primary-01 fa-sharp fa-thin fa-chevron-down"></i>`
						);
					}
				});
		} else {
			$(this).next(".service-more").hide();
		}
	});
}
